import { Component, OnInit, OnDestroy, NgZone } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatDialog } from '@angular/material';
import { Router } from '@angular/router';
import { ClientesModalComponent } from '../modals/clientes-modal/clientes-modal.component';
import { Cliente } from '../models/cliente';
import { Dashboard, ResultadosPeriodoDashboard, ResultDadosGraficos, ResultTotais, ResultVendasUltOrcPed } from '../models/dashboard';
import { PerfilDoUsuario, TipoDeLogAcesso } from '../models/enum';
import { Funcionario } from '../models/funcionario';
import { CRMHierarquiaUsuario } from '../models/crmhierarquia-usuario';
import { UsuarioLogado } from '../models/usuario-logado';
import { CarregandoService } from '../services/carregando.service';
import { ClienteService } from '../services/cliente.service';
import { FuncionarioService } from '../services/funcionario.service';
import { CRMHierarquiaUsuarioService } from '../services/crmhierarquia-usuario.service';
import { GlobalService } from '../services/global.service';
import { NotificacaoService } from '../services/notificacao.service';
import { PedidoService } from '../services/pedido.service';
import { UtilitarioService } from '../services/utilitario.service';
import { MateriaService } from '../services/materia.service';
import { PromocaoService } from '../services/promocao.service';
import { Promocao } from '../models/promocao';
import { Materia } from '../models/materia';
import { PremissasService } from '../services/premissas.service';
import { Configuracao } from '../models/configuracao';
import { Subscription, BehaviorSubject } from 'rxjs';
import { SerieGrafico } from '../models/grafico';
import { PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';
import { UsuarioIntegrador } from '../models/usuario-integrador';
import { UsuarioIntegradorService } from '../services/usuario-integrador.service';
import { EtapaService } from '../services/etapa.service';
import { LogAcesso } from '../models/log-acesso';
import { LogAcessoService } from '../services/log-acesso.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { PremissasSistema } from "../models/premissas-sistema";

// jquery
declare var $: any;

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss']
})
export class DashboardComponent implements OnInit, OnDestroy {
  public atualizouSubject: BehaviorSubject<any>;
  floatLabelControl = new FormControl('todos');

  dados: Dashboard;
  dadosPeriodoDashboard: ResultadosPeriodoDashboard = new ResultadosPeriodoDashboard();
  dadosResultVendasUltOrcPed: ResultVendasUltOrcPed = new ResultVendasUltOrcPed();
  dadosResultGraficos: ResultDadosGraficos = new ResultDadosGraficos();
  dadosTotais: ResultTotais = new ResultTotais();

  pInicio: Date;
  pFim: Date;
  texto = 'Dashboard';
  periodoSelecionado = 1;

  periodos = [
    { id: 0, name: 'Todos' },
    { id: 1, name: 'Mês Atual' },
    { id: 2, name: 'Mês Passado' },
    { id: 3, name: 'Personalizado' },
    { id: 4, name: 'Hoje' },
    { id: 5, name: 'Ontem' },
    { id: 6, name: 'Semana' },
    { id: 7, name: 'Últimos 3 Meses' },
    { id: 8, name: 'Últimos 6 Meses' },
    { id: 9, name: 'Ano Atual' }
  ];

  multi: any[];

  public config: PerfectScrollbarConfigInterface = {};
  public configUltimos: PerfectScrollbarConfigInterface = {};

  // options
  showXAxis = false;
  showYAxis = true;
  gradient = false;
  showLegend = true;
  showXAxisLabel = false;
  xAxisLabel = 'Country';
  showYAxisLabel = true;

  colorScheme = {
    // domain: ['#5AA454', '#A10A28', '#C7B42C', '#AAAAAA']
  };

  vendedores: CRMHierarquiaUsuario[] = [];
  clientes: Cliente[] = [];
  perfil: PerfilDoUsuario;
  PerfilDoUsuario = PerfilDoUsuario;
  usuarioLogado: UsuarioLogado;
  integrador = false;

  vendedorSelecionado: any;
  integradorSelecionado: any;
  administrador = false;
  idVisual = {
    urlLogo: '',
    urlBackground: '',
    domain: [],
    cores: {
      corPrincipal: '',
      corDefault: '',
      corPrimary: '',
      corInfo: '',
      corSuccess: '',
      corWarning: '',
      corDanger: '',
      corRose: '',
      corGraficos: '',
      usarCorSecundariaNosBotoes: false,
    }
  };

  idUsuarioIntegrador;

  usuariosDoIntegrador: UsuarioIntegrador[] = [];

  promocoes: Promocao[] = [];
  materias: Materia[] = [];

  fidelidadeGoSolar = false;
  pMostrarRecebimentos = false;

  private configuracaoSubscription$: Subscription;

  etapas = [];
  etapasSelecionadas = [];

  configuracao: Configuracao = new Configuracao();

  pesquisaPorTimes = false;
  funcionario = null;

  buscouEtapas = false;
  buscouVendedores = false;
  buscouUsuarios = false;
  buscouUsuariosDoIntegrador = false;

  buscouDadosDashboard = false;
  buscouResultadosPeriodo = false;
  buscouResultVendasUltOrcPed = false;
  buscouResultGraficos = false;
  buscouResultTotais = false;

  buscouFidelidadeGoSolar = false;
  buscouPromocoes = false;
  buscouMaterias = false;
  buscouMostrarRecebimentosDashboard = false;
  buscouVisualizarArquivo = false;
  buscouClientes = false;

  premissasSistema: PremissasSistema = new PremissasSistema();

  private subscriptionResultPeriodo$: Subscription;
  private subscriptionResultVendasUltOrcPed$: Subscription;
  private subscriptionResultGraficos$: Subscription;
  private subscriptionResultTotais$: Subscription;
  private subscriptionBuscarDados$: Subscription;

  constructor(
    private pedidoService: PedidoService,
    public utilitarioService: UtilitarioService,
    private carregandoService: CarregandoService,
    private notificacaoService: NotificacaoService,
    private router: Router,
    private globalService: GlobalService,
    private clienteService: ClienteService,
    private funcionarioService: FuncionarioService,
    private hierarquiaService: CRMHierarquiaUsuarioService,
    public dialog: MatDialog,
    private materiaService: MateriaService,
    private promocaoService: PromocaoService,
    private premissasService: PremissasService,
    private usuarioIntegradorService: UsuarioIntegradorService,
    private etapaService: EtapaService,
    private logAcessoService: LogAcessoService,
    private spinner: NgxSpinnerService,
    private ngZone: NgZone
  ) {
    this.atualizouSubject = new BehaviorSubject<any>(undefined);
  }

  public async ngOnInit() {
    await this.buscarPremissas();
    this.buscarEtapas();

    this.administrador = await this.globalService.administrador();
    this.perfil = await this.globalService.perfil();
    this.usuarioLogado = await this.globalService.consultaUsuario();
    this.integrador = await this.globalService.integrador();

    if (!this.integrador) {
      this.buscarVendedores();
      // this.buscarClientes();
    } else if (this.usuarioLogado.verTodosPedidos) {
      this.buscarUsuariosDoIntegrador();
    }

    this.destroySubscriptionResultPeriodo();
    this.destroySubscriptionResultVendasUltOrcPed();
    this.destroySubscriptionResultGraficos();
    this.destroySubscriptionResultTotais();
    this.destroySubscriptionBuscarDados();

    this.buscarResultadosPeriodoDashboard(this.periodoSelecionado);
    this.buscarResultVendasUltOrcPed(this.periodoSelecionado);
    this.buscarResultGraficos(this.periodoSelecionado);
    this.buscarResultTotais(this.periodoSelecionado);
    this.buscarDadosDashboard(this.periodoSelecionado);

    // this.buscarPromocoes();
    // this.buscarMaterias();

    this.buscarMostrarRecebimentosDashboard();

    this.configuracaoSubscription$ = this.globalService.alterouConfiguracao.subscribe((conf: Configuracao) => {
      this.configuracao = conf;

      this.configuracao.esquemaDeCores = { domain: this.idVisual.domain };
    });
  }

  destroySubscriptionResultPeriodo() {
    if (this.subscriptionResultPeriodo$ !== null && this.subscriptionResultPeriodo$ !== undefined) {
      this.subscriptionResultPeriodo$.unsubscribe();
      this.subscriptionResultPeriodo$ = undefined;
    }
  }

  destroySubscriptionResultVendasUltOrcPed() {
    if (this.subscriptionResultVendasUltOrcPed$ !== null && this.subscriptionResultVendasUltOrcPed$ !== undefined) {
      this.subscriptionResultVendasUltOrcPed$.unsubscribe();
      this.subscriptionResultVendasUltOrcPed$ = undefined;
    }
  }

  destroySubscriptionResultTotais() {
    if (this.subscriptionResultTotais$ !== null && this.subscriptionResultTotais$ !== undefined) {
      this.subscriptionResultTotais$.unsubscribe();
      this.subscriptionResultTotais$ = undefined;
    }
  }

  destroySubscriptionResultGraficos() {
    if (this.subscriptionResultGraficos$ !== null && this.subscriptionResultGraficos$ !== undefined) {
      this.subscriptionResultGraficos$.unsubscribe();
      this.subscriptionResultGraficos$ = undefined;
    }
  }

  destroySubscriptionBuscarDados() {
    if (this.subscriptionBuscarDados$ !== null && this.subscriptionBuscarDados$ !== undefined) {
      this.subscriptionBuscarDados$.unsubscribe();
      this.subscriptionBuscarDados$ = undefined;
    }
  }

  async buscarPremissas() {
    this.carregandoService.mostra('buscarPremissasSistema');
    this.premissasService.consultarPremissasSistema().subscribe(
      (premissas) => {
        this.premissasSistema = premissas;

        this.carregandoService.esconde('buscarPremissasSistema');
      },
      (erro) => {
        this.carregandoService.esconde('buscarPremissasSistema');
        this.notificacaoService.erro(erro);
      }
    );
  }

  buscarEtapas() {
    this.buscouEtapas = false;

    this.etapaService.consultarParaFiltro().subscribe(resp => {
      this.etapas = resp;

      this.buscouEtapas = true;
    }, (erro) => {
      this.buscouEtapas = true;
      this.notificacaoService.erro(erro);
    });
  }

  buscarDadosDashboard(tipo, inicio?, fim?) {
    let etapas;

    if (this.etapasSelecionadas && this.etapasSelecionadas.length > 0) {
      etapas = this.etapasSelecionadas.join(',');
    }

    this.spinner.show('spnResultados');
    this.buscouDadosDashboard = false;
    this.subscriptionBuscarDados$ = this.pedidoService.buscarDadosDashboard(tipo, inicio, fim, (this.vendedorSelecionado === 0 ? undefined : this.vendedorSelecionado === -1 ? this.usuarioLogado.id : this.vendedorSelecionado), this.integradorSelecionado, this.integrador && !this.usuarioLogado.verTodosPedidos ? this.usuarioLogado.idUsuarioIntegrador : this.idUsuarioIntegrador, etapas, this.pesquisaPorTimes).subscribe(
      (forms) => {
        this.dados = forms;

        this.atualizouSubject.next(this.dados);

        this.spinner.hide('spnResultados');
        this.buscouDadosDashboard = true;
      },
      (erro) => {
        this.spinner.hide('spnResultados');
        this.buscouDadosDashboard = true;
        this.notificacaoService.erro(erro);
      }
    );
  }

  buscarResultadosPeriodoDashboard(tipo, inicio?, fim?) {
    let etapas;

    if (this.etapasSelecionadas && this.etapasSelecionadas.length > 0) {
      etapas = this.etapasSelecionadas.join(',');
    }

    this.spinner.show('spnResultadosPeríodoDashboard');
    this.buscouResultadosPeriodo = false;

    this.subscriptionResultPeriodo$ = this.pedidoService.buscarResultadosPeriodoDashboard(
      tipo,
      inicio,
      fim,
      (this.vendedorSelecionado === 0 ? undefined : this.vendedorSelecionado === -1 ? this.usuarioLogado.id : this.vendedorSelecionado),
      this.integradorSelecionado,
      this.integrador && !this.usuarioLogado.verTodosPedidos ? this.usuarioLogado.idUsuarioIntegrador : this.idUsuarioIntegrador,
      etapas,
      this.pesquisaPorTimes
    ).subscribe(
      (data) => {
        this.dadosPeriodoDashboard = data;

        this.spinner.hide('spnResultadosPeríodoDashboard');
        this.buscouResultadosPeriodo = true;
      },
      (erro) => {
        this.spinner.hide('spnResultadosPeríodoDashboard');
        this.buscouResultadosPeriodo = true;
        this.notificacaoService.erro(erro);
      }
    );
  }

  buscarResultVendasUltOrcPed(tipo, inicio?, fim?) {
    let etapas;

    if (this.etapasSelecionadas && this.etapasSelecionadas.length > 0) {
      etapas = this.etapasSelecionadas.join(',');
    }

    this.spinner.show('spnResultVendasUltOrcPed');
    this.buscouResultVendasUltOrcPed = false;

    this.subscriptionResultVendasUltOrcPed$ = this.pedidoService.buscarResultVendasUltOrcPed(
      tipo, inicio, fim, (this.vendedorSelecionado === 0 ? undefined : this.vendedorSelecionado === -1 ? this.usuarioLogado.id : this.vendedorSelecionado), this.integradorSelecionado, this.integrador && !this.usuarioLogado.verTodosPedidos ? this.usuarioLogado.idUsuarioIntegrador : this.idUsuarioIntegrador, etapas, this.pesquisaPorTimes
    ).subscribe(
      (data) => {
        this.dadosResultVendasUltOrcPed = data;

        this.spinner.hide('spnResultVendasUltOrcPed');
        this.buscouResultVendasUltOrcPed = true;
      },
      (erro) => {
        this.spinner.hide('spnResultVendasUltOrcPed');
        this.buscouResultVendasUltOrcPed = true;
        this.notificacaoService.erro(erro);
      }
    );
  }

  buscarResultGraficos(tipo, inicio?, fim?) {
    let etapas;

    if (this.etapasSelecionadas && this.etapasSelecionadas.length > 0) {
      etapas = this.etapasSelecionadas.join(',');
    }

    this.spinner.show('spnResultGraficos');
    this.buscouResultGraficos = false;

    this.subscriptionResultGraficos$ = this.pedidoService.buscarDadosGraficos(
      tipo,
      inicio,
      fim,
      (this.vendedorSelecionado === 0 ? undefined : this.vendedorSelecionado === -1 ? this.usuarioLogado.id : this.vendedorSelecionado),
      this.integradorSelecionado,
      this.integrador && !this.usuarioLogado.verTodosPedidos ? this.usuarioLogado.idUsuarioIntegrador : this.idUsuarioIntegrador,
      etapas,
      this.pesquisaPorTimes
    ).subscribe(
      (data) => {
        this.dadosResultGraficos = data;

        this.spinner.hide('spnResultGraficos');
        this.buscouResultGraficos = true;
      },
      (erro) => {
        this.spinner.hide('spnResultGraficos');
        this.buscouResultGraficos = true;
        this.notificacaoService.erro(erro);
      }
    );
  }

  buscarResultTotais(tipo, inicio?, fim?) {
    let etapas;

    if (this.etapasSelecionadas && this.etapasSelecionadas.length > 0) {
      etapas = this.etapasSelecionadas.join(',');
    }

    this.spinner.show('spnResultTotais');
    this.buscouResultTotais = false;

    this.subscriptionResultTotais$ = this.pedidoService.buscarDadosTotais(
      tipo,
      inicio,
      fim,
      (this.vendedorSelecionado === 0 ? undefined : this.vendedorSelecionado === -1 ? this.usuarioLogado.id : this.vendedorSelecionado),
      this.integradorSelecionado,
      this.integrador && !this.usuarioLogado.verTodosPedidos ? this.usuarioLogado.idUsuarioIntegrador : this.idUsuarioIntegrador,
      etapas,
      this.pesquisaPorTimes
    ).subscribe(
      (data) => {
        this.dadosTotais = data;

        this.spinner.hide('spnResultTotais');
        this.buscouResultTotais = true;
      },
      (erro) => {
        this.spinner.hide('spnResultTotais');
        this.buscouResultTotais = true;
        this.notificacaoService.erro(erro);
      }
    );
  }

  buscarUsuariosDoIntegrador() {
    this.buscouUsuariosDoIntegrador = false;
    this.usuarioIntegradorService.consultarPorIdIntegrador(this.usuarioLogado.id).subscribe(
      (f) => {
        this.usuariosDoIntegrador = f;
        const usuTodos = new UsuarioIntegrador();
        usuTodos.nome = 'Todos';
        usuTodos.id = undefined;
        this.usuariosDoIntegrador.unshift(usuTodos);
        this.buscouUsuariosDoIntegrador = true;
      },
      (erro) => {
        this.buscouUsuariosDoIntegrador = true;
        this.notificacaoService.erro(erro);
      }
    );
  };

  buscarMostrarRecebimentosDashboard() {
    this.buscouMostrarRecebimentosDashboard = false;
    this.premissasService.consultarMostrarRecebimentosDashboard().subscribe(rec => {
      if (rec.valor) {
        this.pMostrarRecebimentos = rec.valor;
      }

      this.buscouMostrarRecebimentosDashboard = true;
    }, (erro) => {
      this.buscouMostrarRecebimentosDashboard = true;
      this.notificacaoService.erro(erro);
    });
  }

  buscarPromocoes() {
    this.buscouPromocoes = false;
    this.promocaoService.consultarPromocoesDashboard().subscribe(
      (promocoes) => {
        this.promocoes = promocoes;

        const promises = this.promocoes.map(promo => {
          if (!promo.buscouImagem) {
            promo.imagem$ = this.promocaoService.consultarImagemThumbPorId(promo.id)
              .map(m => this.utilitarioService.toBase64ComInicio(m))
              .toPromise();

            return promo.imagem$.then(p => {
              promo.buscouImagem = true;
            });
          }
          return Promise.resolve();
        });

        Promise.all(promises).then(() => {
          // Espera o Angular renderizar o DOM
          this.ngZone.runOutsideAngular(() => {
            setTimeout(() => {
              $('#carouselIndicators-mesc').carousel({
                interval: 5000,
                ride: 'carousel'
              });
            }, 100);
          });
        });

        this.buscouPromocoes = true;
      },
      (erro) => {
        this.buscouPromocoes = true;
        this.notificacaoService.erro(erro);
      }
    );
  }

  buscarMaterias() {
    this.buscouMaterias = false;
    this.materiaService.consultarMateriasDashboard().subscribe(
      (materias) => {
        this.materias = materias;

        this.materias.forEach(mat => {
          if (!mat.buscouImagem) {
            mat.imagem$ = this.materiaService.consultarImagemThumbPorId(mat.id)
              .map(m => this.utilitarioService.toBase64ComInicio(m)).toPromise();
            mat.imagem$.then(p => {
              mat.buscouImagem = true;
            });
          }
        });

        this.buscouMaterias = true;
      },
      (erro) => {
        this.buscouMaterias = true;
        this.notificacaoService.erro(erro);
      }
    );
  }

  visualizarPromocao(promo) {
    if (promo.idProduto) {
      this.router.navigate(['/kitfechado'], {
        state: { idProduto: promo.idProduto },
      });
      return;
    }

    this.buscouVisualizarArquivo = false;
    this.promocaoService.consultarImagemPorId(promo.id)
      .subscribe(arq => {
        this.utilitarioService.mostrarImagemBlob(arq, '');
        this.buscouVisualizarArquivo = true;
      },
        (erro) => {
          this.buscouVisualizarArquivo = true;
          this.notificacaoService.erro(erro);
        }
      );
  }

  onSelect(event) {
    this.irParaPedidos(this.dadosResultGraficos.valoresGraficoQuantidades.find(p => p.name === event.name).id);
  }

  definePeriodo() {
    if (this.periodoSelecionado !== 3) {
      this.buscarDadosDashboard(this.periodoSelecionado);
      this.buscarResultadosPeriodoDashboard(this.periodoSelecionado);
      this.buscarResultTotais(this.periodoSelecionado);
      this.buscarResultVendasUltOrcPed(this.periodoSelecionado);
      this.buscarResultGraficos(this.periodoSelecionado);
    }
    else {
      if (this.pInicio && this.pFim) {
        this.buscarDadosDashboard(this.periodoSelecionado,
          this.pInicio && typeof this.pInicio !== 'string' ? this.pInicio.toISOString() : this.pInicio,
          this.pFim && typeof this.pFim !== 'string' ? this.pFim.toISOString() : this.pFim);

        this.buscarResultadosPeriodoDashboard(this.periodoSelecionado,
          this.pInicio && typeof this.pInicio !== 'string' ? this.pInicio.toISOString() : this.pInicio,
          this.pFim && typeof this.pFim !== 'string' ? this.pFim.toISOString() : this.pFim);

        this.buscarResultVendasUltOrcPed(this.periodoSelecionado);
        this.buscarResultGraficos(this.periodoSelecionado,
          this.pInicio && typeof this.pInicio !== 'string' ? this.pInicio.toISOString() : this.pInicio,
          this.pFim && typeof this.pFim !== 'string' ? this.pFim.toISOString() : this.pFim);
      }
    }

  }

  irParaPedidos(etapa) {
    this.router.navigate(['pedidos'],
      {
        state: {
          filtro: { dataInicio: this.dados.dataInicio, dataFim: this.dados.dataFim, etapa: etapa, vendedor: this.vendedorSelecionado, integrador: this.integradorSelecionado }
        }
      });
  }

  alterouPesquisarPorTimes() {
    this.integradorSelecionado = undefined;
    this.idUsuarioIntegrador = undefined;
    this.vendedorSelecionado = undefined;
    this.buscarVendedores(true);
  }

  buscarVendedores(pesquisar?) {
    if (!this.pesquisaPorTimes && this.administrador) {
      this.buscouVendedores = false;

      this.funcionarioService.consultarFuncionariosPedido().subscribe(resp => {
        this.vendedores = resp.map(p => ({ idFuncion: Number(p.idFuncion), nome: p.nome }));
        if (this.vendedores.length > 1) {
          this.vendedores.unshift({ idFuncion: 0, nome: 'Todos' });
        }

        if (pesquisar) {
          this.definePeriodo();
        }

        this.buscarClientes();

        this.buscouVendedores = true;
      }, (erro) => {
        this.notificacaoService.erro(erro);
        this.buscouVendedores = true;
      });
    }
    else {
      this.buscouUsuarios = false;

      this.hierarquiaService.consultarHierarquiaDoUsuarioLista(undefined, this.pesquisaPorTimes).subscribe(resp => {
        this.vendedores = resp;

        if (this.vendedores.some(p => p.idFuncion === Number(this.usuarioLogado.id))) {
          this.vendedores.splice(this.vendedores.
            indexOf(this.vendedores.find(p => p.idFuncion === Number(this.usuarioLogado.id))), 1);
        }

        if (this.vendedores.length > 0) {
          const todos = new CRMHierarquiaUsuario();
          todos.idFuncion = 0;
          todos.nome = 'Todos';
          this.vendedores.unshift(todos);
        }

        const somenteEu = new CRMHierarquiaUsuario();
        somenteEu.idFuncion = -1;
        somenteEu.nome = 'Somente eu';
        this.vendedores.unshift(somenteEu);

        if (this.vendedores.length === 1) {
          this.vendedorSelecionado = -1;
          pesquisar = true;
        }

        if (pesquisar) {
          this.definePeriodo();
        }

        this.buscarClientes();

        this.buscouUsuarios = true;
      }, (erro) => {
        this.buscouUsuarios = true;
        this.notificacaoService.erro(erro);
      });
    }
  }


  buscarClientes() {
    this.buscouClientes = false;

    this.integradorSelecionado = undefined;
    this.clienteService.consultarClientesDoVendedor(this.vendedorSelecionado === 0 ? undefined : this.vendedorSelecionado === -1 ? this.usuarioLogado.id : this.vendedorSelecionado).subscribe(resp => {
      this.clientes = resp;
      const todos = new Cliente();
      todos.id = undefined;
      todos.nome = 'Todos';
      this.clientes.unshift(todos);

      this.buscouClientes = true;
    }, (erro) => {
      this.buscouClientes = true;
      this.notificacaoService.erro(erro);
    });
  }


  pesquisarCliente() {
    const dialogRef = this.dialog.open(ClientesModalComponent, {
      width: ($('body').width()).toString() + 'px',
      data: {
        gi: 1,
        esconderBotao: true,
        pesquisarPorVendedor: true,
        idVendedor: this.vendedorSelecionado === -1 ? this.usuarioLogado.id : this.vendedorSelecionado
      },
      panelClass: 'modal-card'
    });

    dialogRef.afterClosed().subscribe((result: any) => {
      if (result) {
        this.integradorSelecionado = result.cliente.id;
      }
    }
    );
  }

  ngOnDestroy() {
    if (this.configuracaoSubscription$ !== undefined && this.configuracaoSubscription$ !== null) {
      this.configuracaoSubscription$.unsubscribe();
    }

    this.destroySubscriptionResultPeriodo();
    this.destroySubscriptionResultVendasUltOrcPed();
    this.destroySubscriptionResultGraficos();
    this.destroySubscriptionResultTotais();
    this.destroySubscriptionBuscarDados();
  }


  handleRowClick(route: string, state: object) {
    this.router.navigate([route], { state });
  }

  gerarLogAcesso(idCupom: string, tipo: TipoDeLogAcesso) {
    const logAcesso: LogAcesso = {
      tipo,
      idCupom,
    };

    this.logAcessoService.Salvar(logAcesso).subscribe(() => { });
  }

  editarPedido(flag: number, idCupom: string) {
    if (flag === 4 && !this.premissasSistema.habilitaOrcamento) {
      return;
    }

    this.gerarLogAcesso(idCupom, TipoDeLogAcesso.EditarPedido);
    this.router.navigate(['/pedidos/editar', idCupom]);
  }

}
